<template>
  <div>
    <div class="user_box">
      <div class="user_title">
        <div class="issue"><span>?</span></div>
        <span>用户帮助中心</span>
      </div>
      <div class="centre">
        <ul>
          <li @click="center(1)">
            <div>文字</div>
            <p>文字著作权登记指南</p>
          </li>
          <li @click="center(2)">
            <div>口述</div>
            <p>口述著作权登记指南</p>
          </li>
          <li @click="center(3)">
            <div>音乐</div>
            <p>音乐著作权登记指南</p>
          </li>
          <li @click="center(4)">
            <div>戏剧</div>
            <p>戏剧著作权登记指南</p>
          </li>
          <li @click="center(5)">
            <div>曲艺</div>
            <p>曲艺著作权登记指南</p>
          </li>
          <li @click="center(6)">
            <div>舞蹈</div>
            <p>舞蹈著作权登记指南</p>
          </li>
          <li @click="center(7)">
            <div>杂技</div>
            <p>杂技著作权登记指南</p>
          </li>
          <li @click="center(8)">
            <div>美术</div>
            <p>美术著作权登记指南</p>
          </li>
          <li @click="center(9)">
            <div>建筑</div>
            <p>建筑著作权登记指南</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: "",
    };
  },
  created() {
    this.cra();
  },
  methods: {
    center(id) {
      // console.log(id)
      this.$router.push({
        path: "/help_center",
        query: { id: id },
      });
    },
    cra() {
      // console.log('data111')
    },
  },
};
</script>

<style lang='less' scoped>
.centre {
  padding-top: 4px;
  margin-left: 100px;
  width: 650px;
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      cursor: pointer;
      margin-top: 70px;
      width: 162px;
      height: 100px;
      flex: 0 0 33%;
      div {
        margin: 0 auto;
        background:  #0068b7;
        border-radius: 10px;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 17px;
        color: #ffffff;
        margin-bottom: 14px;
      }
      p {
        font-size: 18px;
         
        font-weight: 400;
        color: #333333;
        opacity: 1;
        text-align: center;
      }
    }
  }
}
.issue {
  width: 31px;
  height: 31px;
  font-size: 21px;
   
  color: #ffffff;
  opacity: 1;
  background:  #0068b7;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  line-height: 31px;
}
.user_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
   
  background: #fff;
  overflow: auto;
  .user_title {
    margin-top: 50px;
    margin-left: 100px;
    color:  #0068b7;
    font-size: 28px;
    font-weight: 600;
  }
  .user_info {
    margin-top: 50px;
    margin-left: 122px;
    .info_item {
      display: flex;
      position: relative;
      margin-bottom: 40px;
      .info_item_left {
        width: 161px;
        font-size: 22px;
        height: 28px;
        line-height: 28px;
        color: #666666;
      }
      .info_item_right {
        font-size: 20px;
        height: 28px;
        line-height: 28px;
        color: #333333;
      }
      .icon1 {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .modify {
        position: absolute;
        left: 531px;
        color:  #0068b7;
        height: 28px;
        font-size: 20px;
         
        font-weight: 400;
        line-height: 28px;
        color:  #0068b7;
        opacity: 1;
      }
    }
  }
}
.avatar-uploader {
  width: 480px;
  height: 260px;
  background: #ffffff;
  border: 1px solid #d0d0d0;
  opacity: 1;
  border-radius: 10px;
  margin-bottom: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
#avatar1 .el-upload--text,
#avatar .el-upload--text {
  margin: 0;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 480px;
  height: 260px;
  line-height: 260px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 200px;
  display: block;
}
.user_box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  display: none;
}
.user_box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ebebeb;
}
.user_box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 10px;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/view/help/usercentre.vue